<template>
  <h-list-page class="add-notice-container">
    <div class="notice-btn-group">
      <div class="notice-title">{{ h_i18n('1432c7fcdba00f248023082857b52281') }}</div>
      <div class="btn-group">
        <div class="reset-btn" @click="handleCancel">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</div>
        <div class="primary-btn marginL12" @click="handleSave">{{ h_i18n('be5fbbe34ce9979bfb6576d9eddc5612') }}</div>
      </div>
    </div>
    <div style="width:100%;background: #fff;border-radius: 8px;margin:12px auto;box-sizing: border-box;">
      <div style="max-width:700px;margin: 0 auto;padding: 16px 0;">
        <div class="item-content">
          <div class="item-label">{{ h_i18n('32c65d8d7431e76029678ec7bb73a5ab') }}<span class="icon-style">*</span></div>
          <el-input v-model="addObj.title" maxlength="50" :placeholder="h_i18n('96641a78cfd9f9f8ba68f0524347b186')"/>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('f1bd8b053770a696fc8646ca911c9520') }}<span class="icon-style">*</span></div>
          <el-select v-model="addObj.noticeType" :placeholder="h_i18n('1be9b0e068cdce00eb5f9c9634268cc9')">
            <el-option :label="h_i18n('1432c7fcdba00f248023082857b52281')" value="1" />
            <el-option :label="h_i18n('20faa88f0d2f0ab5f771e88deb352132')" value="2" />
            <!-- <el-option label="流程文件" value="3" /> -->
            <el-option :label="h_i18n('50d52dd929a75bb9b0f4afb0b7d879e1')" value="4" />
          </el-select>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('5ad2f695c4da24b49ba8a77a2bb01c5c') }}<span class="icon-style">*</span></div>
          <el-select v-model="addObj.visibleType" :placeholder="h_i18n('94499db3a370bf600e4faead59ae31fe')">
            <el-option :label="h_i18n('0d7942407f51e1b3cb2e995a80ca4098')" value="0" />
            <el-option :label="h_i18n('b15edc81a94344441dd027c72358d605')" value="1" />
            <el-option :label="h_i18n('7acc1680a5f6ee408eae017701ce7ccf')" value="2" />
          </el-select>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('5fb17cfefdae401de0acbc52bf309042') }}<span class="icon-style">*</span></div>
          <el-date-picker v-model="addObj.uploadTime" type="date" :placeholder="h_i18n('61b7c646a1d32f102fe2a4993eda92e9')" formate="YYYY-MM-DD" class="myDate" style="width: 100%;width: 420px !important;">

          </el-date-picker>
        </div>
        <!-- <div class="item-content">
          <div class="item-label">有效期<span class="icon-style">*</span></div>
          <el-date-picker v-model="addObj.expirationDate" type="date" placeholder="请选择有效期" format="YYYY-MM-DD" class="myDate" style="width: 100%;width: 420px !important;"/>
        </div> -->
        <!-- <div class="item-content">
          <div class="item-label">是否发布</div>
          <el-radio-group v-model="addObj.isPublish">
            <el-radio value="0" size="large" label="0">否</el-radio>
            <el-radio value="1" size="large" label="1">是</el-radio>
          </el-radio-group>
        </div> -->
        <!-- <div class="item-content">
          <div class="item-label">功能关联</div>
          <el-cascader v-model="addObj.resourceCodeList" :options="menuList" :props="deptsProps" :append-to-body="false" popper-class="custom-cascader" style="width: 420px;"/>
        </div> -->
        <div class="item-content">
          <div class="item-label">{{ h_i18n('a6fc9e3ae6f4333a43ffc1774a0b4347') }}<span class="icon-style">*</span></div>
          <hc-file-upload
            :info="h_i18n('1cf116a7aa9fef670f590827de46ea19')"
            v-model="fileObj"
            delete
            download
            accept="other"
            acceptOther="pdf,PDF"
            @change="upLoadImg"
            @delete="deleteFile"
            @error="error"
            @download="handleDownLoad(addObj.fileUuid,addObj.fileName)"></hc-file-upload>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('3bdd08adab6ea90b9164b20a0e4151ac') }}</div>
          <div id="charEditor" style="position: relative;z-index: 1;"></div>
        </div>
        
      </div>
    </div>
  </h-list-page>
</template>
<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import E from 'wangeditor'
let editor = null
import moment from 'moment'
export default {
  data(){
    return{
      editor: null,
      html: '<p>hello</p>',
      toolbarConfig: { },
      editorConfig: { placeholder: h_i18n('cdd6fe7d2f5b543696d8841e2abd2315') },
      mode: 'default', // or 'simple'
      // uploadSrc: 'https://pre-hwork.haier.net/hmqm-mkhl-front/unload/chatfile/upload',
      uploadSrc: "/base/fileUpload/uploadToOss",
      addObj:{
        title:'',
        isPublish: 0
      },
      fileObj:{},
      rules:[],
      menuList:[],//关联功能
      deptsProps:{
        value: "resourceCode",
        label: "resourceName",
        children: 'child',    //子元素字段名
        multiple: true,
        expandTrigger: 'hover',
        checkStrictly: false,
	    }
    }
  },
  methods:{
    h_i18n,
    upLoadImg(options, promise) {
      this.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
      let formData = new FormData();
      formData.append("files", options.file);
      this.$http({
        method: "post",
        url: "/base/fileUpload/uploadToOss",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then((res) => {
        this.addObj.fileUuid = res.data.data;
        this.addObj.fileName = options.file.name;
        this.closeLoading()
      }).catch((err) => {
        this.closeLoading()
        this.error(err.data.msg||h_i18n('8e2f993840e3108c7f6d8f23d6a8a08d'));
      });
    },
    deleteFile() {
      this.addObj.fileUuid = "";
      this.addObj.fileName = "";
      this.fileObj = undefined
    },
    error(str){
      this.warning({ title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str, confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721') });
    },
    handleDownLoad(fileUuid,fileName){
      if(fileUuid == ""||fileUuid == undefined ||fileUuid == null){
        this.info(h_i18n('e334e916fdda30d81fe74a8cdeb97d65'));
        return false;
      }
      this.$http({
        method: "get",
        // url: `/vmiService/fileDownload/downloadFilesqm?type=9&filePath=${fileUuid}`,
        url: `/base/fileDownload/downLoadFileFtp?type=9&fileUUID=${fileUuid}`,
        responseType: "blob",
      }).then((res) => {
        console.log('res=====',res)
        if (res.status == 200) {
          let suffix = fileName.substring(fileName.lastIndexOf('.'))
          // let blob = BlobType(suffix,res.data); // 文件流
          let blobUrl = URL.createObjectURL(res.data);
          const link = document.createElement("a"); //模拟a链接，不支持低版本ie
          link.download = fileName;
          link.style.display = "none";
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }else{
          this.info(res.message)
        }
      });
    },
    handleSave(){
      
      // moment(this.searchData.beginDateOne).format("YYYY-MM-DD HH:mm:ss")
      if(this.addObj.title==''||this.addObj.title==null||this.addObj.title==undefined){
        this.info(h_i18n('5e562fdf4e5bfe260750236e2eb91a25'));
        return false;
      }
      if(this.addObj.noticeType==''||this.addObj.noticeType==null||this.addObj.noticeType==undefined){
        this.info(h_i18n('ff04d85348387d7c072b460005283a0f'));
        return false;
      }
      if((this.addObj.visibleType==''||this.addObj.visibleType==null||this.addObj.visibleType==undefined)&&this.addObj.visibleType!='0'){
        this.info(h_i18n('e3f7a81e5a34697bc3b735cf11893b3d'));
        return false;
      }
      if(this.addObj.uploadTime==''||this.addObj.uploadTime==null||this.addObj.uploadTime==undefined){
        this.info(h_i18n('072a4558c3d8d9d8ee8473f907458df4'));
        return false;
      }
      // if(this.addObj.expirationDate==''||this.addObj.expirationDate==null||this.addObj.expirationDate==undefined){
      //   this.info("请选择有效期！");
      //   return false;
      // }
      if(this.addObj.fileUuid==''||this.addObj.fileUuid==null||this.addObj.fileUuid==undefined){
        this.info(h_i18n('b7e1c30cb0484f828b0d3fbaa254add2'));
        return false;
      }
      // if(this.addObj.isPublish==''||this.addObj.isPublish==null||this.addObj.isPublish==undefined){
      //   this.info("请选择是否发布！");
      //   return false;
      // }
      // let resourceCodeList = []
      // if(this.addObj.resourceCodeList&&this.addObj.resourceCodeList.length>0){
      //   resourceCodeList = this.addObj.resourceCodeList.join(',')
      // }
      // console.log('resourceCodeListresourceCodeList',resourceCodeList)
      let params = {...this.addObj}
      params.uploadTime = moment(this.addObj.uploadTime).valueOf()
      params.expirationDate = '2099-12-31 23:59:59'
      params.noticeContent = editor.txt.html()
      // params.resourceCodeList = ([resourceCodeList].join(' ')).split(',')
      console.log('324234234resourceCodeList',params)
      // if(params.noticeContent==''||params.noticeContent==null||params.noticeContent==undefined){
      //   this.info("请输入通知内容！");
      //   return false;
      // }
      this.startLoading(h_i18n('f743e1e660b5174e50f127e8ac091fcd'))
      this.$http({
        method: "post",
        url: this.$route.query.id ?"/base/notice/updateNotice": "/base/notice/saveNotice",
        data: {
          ...params
        },
      }).then((res) => {
        console.log(res, "savesavesavesavesavesavesavesave");
        if(res.data.code==0){
          if(this.$route.query.id){
            this.success(h_i18n('1d9b45c60ba4b62726c9ea9e54b704a0'))
          }else{
            this.success(h_i18n('431abbd42aea98c96c1ef1db08b34e43'))
          }
          // this.$router.push({
          //   name:'SystemNotice',
          //   query:{
          //     ...this.$route.query
          //   }
          // })
          this.handleCancel()
        }else{
          this.info(res.data.msg)
        }
        this.closeLoading()
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handleCancel(){
      if (top != self) {
        // console.log("被嵌套了")
        this.$router.back()
        return
      }
      this.addObj = {}
      let params = this.$route.query
      delete params.id
      this.$router.push({
        name:'SystemNotice',
        query:{
          ...params
        }
      })
    },
    getInstance(){
      let _this = this
      editor = new E('#charEditor')
      editor.config.height = 300
      editor.config.showFullScreen = false
      editor.config.showLinkImg = false
      editor.config.excludeMenus = ['emoticon', 'video','undo','redo','list','lineHeight','indent','quote','code','splitLine']
      // editor.config.uploadFileName = 'files';

      // if(process.env.NODE_ENV === 'production'){
      //   this.uploadSrc = 'https://sqm.haier.net/workBench' + this.uploadSrc
      // }else{
      //   this.uploadSrc = 'https://pre-proxy-sqm-front.hwork.haier.net/sqm-workbench' + this.uploadSrc
      // }

      // editor.config.uploadImgServer = this.uploadSrc //配置上传图片的接口地址
      // // editor.config.uploadImgServer = '/upload';
      // editor.config.uploadImgShowBase64 = true
      // editor.config.uploadImgParams = {
      //   secret: '9f907db8-b1ae-4bbc-beb2-be4e4d89a284'
      // }
      // editor.config.uploadImgHooks = { 
      //   error: function (xhr, editor) {
      //     // alert("2：" + xhr + "请查看你的json格式是否正确，图片并没有上传");
      //     // 图片上传出错时触发 如果是这块报错 就说明文件没有上传上去，直接看自己的json信息。是否正确
      //     // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      //   },
      //   fail: function (xhr, editor, result) {
      //     // 如果在这出现的错误 就说明图片上传成功了 但是没有回显在编辑器中，我在这做的是在原有的json 中添加了
      //     // 一个url的key（参数）这个参数在 customInsert也用到
      //     // 
      //     // alert("1：" + xhr + "请查看你的json格式是否正确，图片上传了，但是并没有回显");
      //   },
      //   success:function(xhr, editor, result){
      //     //成功 不需要alert 当然你可以使用console.log 查看自己的成功json情况 
        
      //   },
      //   customInsert: function (insertImg, result, editor) {
      //     // console.log('===============resultresultresultresult',result);
      //     // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
      //     // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
      //     // 举例：假如上传图片成功后，服务器端返回的是 {url:‘....‘} 这种格式，即可这样插入图片：
      //     // insertImg(result.data);
      //     // const imgTag = `<img src="${result.data}" width="100" height="60">`;
      //     const baseUrl =  '/base/fileDownload/downloadFile?filePath='
      //     var text= editor.txt.html()
      //     var textNew=editor.txt.html(text+`<img v-monitor-src  id="editImg" src="${baseUrl + result.data}">`)
      //     // document.execCommand("insertHTML", false, imgTag)
      //   }
    // }
    // 自定义图片上传
    editor.config.customUploadImg = async (files, insertImgFn) => {
       // 只处理第一张图片
       const file = files[0]
       if (!file) return
       try {
         // 创建FormData
         const formData = new FormData()
         formData.append('files', file) // 与后端参数名保持一致
         // 发送上传请求
         const response = await this.$http({
            url:'/base/fileUpload/uploadToOss',
            method: 'POST',
            data: formData
         })
         const result = await response
         if (result.data.code === '0' && result.data?.data) {
           // 回显图片到编辑器
           const previewUrl = await this.getPreviewUrl(result.data.data)
           insertImgFn(previewUrl)
         } else {
          console.log('上传失败: ' + (result.data.msg || '未知错误'))
         }
       } catch (error) {
        console.log('上传失败，请重试',error)
       }
     }
      editor.create()
      if(this.$route.query.editflag){
        this.state.sort = this.$route.query.sort
        this.state.title = this.$route.query.title
        this.state.noticeType = this.$route.query.noticeType
        this.fileSet.name = this.$route.query.fileName
        this.fileSet.fileName = this.$route.query.fileName
        this.fileSet.fileUuid = this.$route.query.fileUuid
        editor.txt.html(this.$route.query.noticeContent)
      }
    },
    async getPreviewUrl (UUID) {
      if(process.env.NODE_ENV === 'production'){
        return 'https://sqm.haier.net/workBench' + '/base/fileDownload/downloadFile?filePath='+UUID
      }else{
        return 'https://pre-proxy-sqm-front.hwork.haier.net/sqm-workbench' + '/base/fileDownload/downloadFile?filePath='+UUID
      }
      // try {
      //   // 1. 调用下载接口接口获取文件二进制数据
      //   const response = await this.$http({
      //     url:'/base/fileDownload/downloadFile?filePath='+UUID,
      //     method: 'GET',
      //     responseType: 'blob' // 重要：指定响应类型为二进制
      //   })
      //   if (response.status != 200 ) {
      //     throw new Error(`下载失败: ${response.statusText}`)
      //   }
      //   // 2. 将二进制数据转换为可预览的DataURL
      //   const blob = response.data
      //   const objectUrl = URL.createObjectURL(blob)
        
      //   return objectUrl
        
      // } catch (error) {
      //   console.error('获取预览图片失败:', error)
      //   throw error
      // }
    },
    getNoticeById(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "get",
        url: `/base/notice/getInfoById?noticeId=${this.$route.query.id}`,
      }).then((res) => {
        if(res.data.code==0){
         this.$nextTick(()=>{
          this.addObj = res.data.data
          editor.txt.html(res.data.data.noticeContent)
          this.addObj.isPublish = String(res.data.data.isPublish)
          // this.addObj.name = res.data.data.fileName
          this.fileObj.fileName = res.data.data.fileName
          this.fileObj.fileUuid = res.data.data.fileUuid
          this.fileObj.name = res.data.data.fileName
          this.addObj.noticeType = String(this.addObj.noticeType)
          this.addObj.visibleType = String(this.addObj.visibleType)
         })
        }
        this.closeLoading()
      }).catch(err=>{
        this.closeLoading()
        console.log(err)
      })
    },
    removeUnwantedNodes(tree) {
      // 如果有子节点，则递归处理子节点
      if (Array.isArray(tree)) {
        tree.forEach((item,index) => {
          if(item.child&&item.child.length>0&&item.child[0].resourceTypeCode == 'MENU'){
            this.removeUnwantedNodes(item.child)
          }else{
            item.child = null
          }
        })
      }
      // 返回经过处理后的当前节点
      return tree
    },
    getNoticeResource(){
      this.$http({
        method: "post",
        data: {'resource_type_code':'MENU','app_code':'SQM',name:this.$route.query.name,nickName:this.$route.query.nickName},
        url: `/base/resource/getResourceTreeByAppCode`,
      }).then((res) => {
        if(res.data.code==0&&res.data&&res.data.data&&res.data.data.length>0){
          let tmpList = [...res.data.data[0].child]
          let arr = []
          tmpList.forEach(e1 => {
            if(e1.child&&e1.resourceTypeCode == 'MENU'){
              arr.push(e1)
              if(e1&&e1.child){
                e1.child.forEach(e2=>{
                  if(e2.child&&e2.resourceTypeCode == 'MENU'){
                    arr.push(e2)
                  } 
                })
              }
            }
          })
          this.menuList = this.removeUnwantedNodes(tmpList)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getNoticeResourceById(){
      this.$http({
        method: "post",
        data: {noticeId:this.$route.query.id},
        url: `/base/noticeResource/getNoticeResourceList`,
      }).then((res) => {
        this.$nextTick(()=>{
          if(res&&res.data&&res.data.data&&res.data.data.length>0){
            let resourceCodeList = res.data.data.map(item=>{
              return item.resourceCode
            })
            this.addObj.resourceCodeList = [...resourceCodeList]
          }
        })
      }).catch(err=>{
        console.log(err)
      })
    },
  },
  beforeRouteLeave(){
    editor.destroy()
  },
  mounted(){
    this.getNoticeResource()
    this.getInstance()
    if(this.$route.query.id){
      this.getNoticeById()
      this.getNoticeResourceById()
    }
    
  }
}
</script>

<style>
.is-hwork{
  box-sizing: border-box;
  width: 100%;
}
.is-hwork .el-input__prefix{
  padding-left: 8px !important;
}
.el-input__icon{
  line-height: 34px !important;
}
</style>

<style>
/* 设置下拉框的最大高度 */
.custom-cascader .el-cascader-panel {
  max-height: 228px; /* 你想要的高度 */
  overflow-y: auto;
}
</style>

<style lang="scss" scoped>

.add-notice-container{
  background: #F2F3F6;
  min-height: 850px;
  .item-content{
    margin: 12px 0;
    .item-label{
      color: #4E5969;
      font-size: 14px;
      margin-bottom: 8px;
      .icon-style{
        position: relative;
        color: red;
        top: 2px;
        left: 5px;
      }
    }
  }
}
.notice-btn-group{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  height: 48px;
  padding: 0 16px;
  .btn-group{
    display: flex;
    flex-direction: row;
    margin-right: 16px;
  }
  .notice-title{
    color: #1D2129;
    font-size: 18px;
  }
}
.primary-btn{
  min-width: 60px;
  max-width: 80px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#165DFF;
  color: #165dff;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.reset-btn{
  width: 60px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#C9CDD4;
  color: #1D2129;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}
.marginL12{
  margin-left: 12px;
}
.myDate :deep(.is-hwork .el-input--prefix:not){
  width: 420px !important;
}
</style>